import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Fallback = ({ resetErrorBoundary }) => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/home");
    resetErrorBoundary();
  };

  return (
    <Box
      height="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="h1">Oops!</Typography>
      <Typography variant="body1">
        Something went wrong, and we're not sure what. Contact{" "}
        <a href="mailto:support@biblioboard.com">support@biblioboard.com</a> for
        help.
      </Typography>
      <Button onClick={goHome}>Go home</Button>
    </Box>
  );
};

export default Fallback;
